import { EthDateTime } from 'ethiopian-calendar-date-converter';

// Helper function to convert Gregorian date to Ethiopian date string
export const getEthiopianDateStr = (date: Date): string => {
  try {
    const ethDateTime = EthDateTime.fromEuropeanDate(date);
    const monthNames = ['መስከረም', 'ጥቅምት', 'ኅዳር', 'ታኅሣሥ', 'ጥር', 'የካቲት', 'መጋቢት', 'ሚያዝያ', 'ግንቦት', 'ሰኔ', 'ሐምሌ', 'ነሐሴ', 'ጳጉሜ'];
    const { year, month, date: dayOfMonth } = ethDateTime;
    return `${monthNames[month - 1]} ${dayOfMonth}, ${year}`;
  } catch (error) {
    console.error('Error converting to Ethiopian date:', error);
    return 'Invalid Date';
  }
};

// Helper function to convert Western time to Ethiopian time
export const getEthiopianTimeStr = (hours: number, minutes: number, showGC: boolean = false): string => {
  try {
    let ethiopianHours: number;
    let timeOfDay: string;

    if (hours >= 6 && hours < 12) {
      // 6 AM to 11 AM -> 12 to 5 ጠዋት
      ethiopianHours = hours === 6 ? 12 : hours - 6;
      timeOfDay = 'ጠዋት';
    } else if (hours >= 12 && hours < 18) {
      // 12 PM to 5 PM -> 6 to 11 ከሰአት
      ethiopianHours = hours === 12 ? 6 : hours - 6;
      timeOfDay = 'ከሰአት';
    } else if (hours >= 18 && hours < 24) {
      // 6 PM to 11 PM -> 12 to 5 ምሽት
      ethiopianHours = hours === 18 ? 12 : hours - 18;
      timeOfDay = 'ምሽት';
    } else {
      // 12 AM to 5 AM -> 6 to 11 ሌሊት
      ethiopianHours = hours === 0 ? 6 : hours + 6;
      timeOfDay = 'ሌሊት';
    }
    
    // Format Ethiopian time more naturally
    const ethiopianTime = minutes > 0 
      ? `${timeOfDay} ${ethiopianHours}:${minutes.toString().padStart(2, '0')} ሰአት`
      : `${timeOfDay} ${ethiopianHours} ሰአት`;
    
    if (showGC) {
      // Format GC time
      const period = hours >= 12 ? 'PM' : 'AM';
      const gcHours = hours % 12 || 12;
      const gcTime = `${gcHours}:${minutes.toString().padStart(2, '0')} ${period}`;
      return `${ethiopianTime} (${gcTime})`;
    }
    
    return ethiopianTime;
  } catch (error) {
    console.error('Error converting to Ethiopian time:', error);
    return 'Invalid Time';
  }
};

// Helper function to format time based on preference
export const getTimeStr = (hours: number, minutes: number, showBoth: boolean = false, timeFormat: 'gregorian' | 'ethiopian' = 'gregorian'): string => {
  // Format GC time
  const period = hours >= 12 ? 'PM' : 'AM';
  const gcHours = hours % 12 || 12;
  const gcTime = `${gcHours}:${minutes.toString().padStart(2, '0')} ${period}`;

  if (timeFormat === 'gregorian') {
    return showBoth ? `${gcTime} (${getEthiopianTimeStr(hours, minutes)})` : gcTime;
  } else {
    return showBoth ? `${getEthiopianTimeStr(hours, minutes)} (${gcTime})` : getEthiopianTimeStr(hours, minutes);
  }
}; 